import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterByProperty'
})
export class FilterByPropertyPipe implements PipeTransform {
  transform(items: any[], propertyName: string, searchTerm: string): any[] {
    if (!items || !propertyName || !searchTerm) {
      return items;
    }

    searchTerm = searchTerm.toLowerCase();
    return items.filter(item => {
      return item[propertyName].toLowerCase().includes(searchTerm);
    });
  }
}